export default {
  methods: {
    renderColgroup() {
      const h = this.$createElement

      const fields = this.computedFields
      let $colgroup = h()

      if (this.hasNormalizedSlot('table-colgroup')) {
        $colgroup = h('colgroup', { key: 'colgroup' }, [
          this.normalizeSlot('table-colgroup', { columns: fields.length, fields })
        ])
      }

      return $colgroup
    }
  }
}
